// extracted by mini-css-extract-plugin
export default {"orders":"orders-btn_orders__b-L2m"};